import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=8fd26312&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=8fd26312&prod&scoped=true&lang=css"
import style1 from "./addOrEdit.vue?vue&type=style&index=1&id=8fd26312&prod&lang=scss&scoped=true"
import style2 from "./addOrEdit.vue?vue&type=style&index=2&id=8fd26312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd26312",
  null
  
)

export default component.exports